
import React, { Component } from 'react';
import ReactDOM from 'react-dom';
var redirectURL = require('../redirectURL');


const UpdateAction = (props) => {
    const handleClick = (e) => {
        e.stopPropagation();
        props.context.componentParent.updateRowHandler(props.data);
    };

    return (
        <div>
			<button onClick={handleClick} className="custom-btn label label-success"><i className="icofont icofont-save"></i> Update </button>
       
        </div>
    );
};

export default UpdateAction;
